module.exports = __webpack_public_path__ + "static/media/top-right.8b4bc243.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lesson-path/img/top-right.png
// module id = 706
// module chunks = 1